import React from 'react'
import './MetricCard.css'

interface MetricCardProps {
  icon: React.ReactNode
  value: number | string
  label: string
  iconColor: string
  formatType?: 'currency' | 'percentage' | 'number'
}

export const MetricCard: React.FC<MetricCardProps> = ({
  icon,
  value,
  label,
  iconColor,
  formatType = 'number'
}) => {
  const formatValue = (val: number | string): string => {
    if (typeof val === 'string') return val

    switch (formatType) {
      case 'currency':
        if (val >= 1000000) {
          return `$${(val / 1000000).toFixed(1)}M`
        } else if (val >= 1000) {
          return `$${(val / 1000).toFixed(0)}K`
        }
        return `$${val.toLocaleString()}`

      case 'percentage':
        return `${val}%`

      case 'number':
      default:
        return val.toLocaleString()
    }
  }

  return (
    <div className="metric-card">
      <div className="metric-card-icon" style={{ color: iconColor }}>
        {icon}
      </div>
      <div className="metric-card-value">{formatValue(value)}</div>
      <div className="metric-card-label">{label}</div>
    </div>
  )
}
